import Vue from 'vue'
const now = Date.now || function() {
	return new Date().getTime();
};
const isArray = Array.isArray || function(obj) {
	return obj instanceof Array;
};
/**
 * 打印对象
 */
const obj2Str = function(obj) {
	return JSON.stringify(obj);
};

const isNone=function(obj){
	if (obj==undefined || obj==null || obj=="" || obj=="undefined" ||obj=="null" )
	{
		return true
	}
	else{
		return false
	}
}

export default {
	obj2Str,
	now,
	isArray,
	isNone,
}
